import * as React from "react";
import { styled } from "sharedUI/styles";
import { OrgIcon } from "designer/apps/orgs/orgs-sidebar/org-icon";
import { useSelector } from "react-redux";
import { RootState } from "store/types";
import { trackEvent } from "analytics";
import { ButtonVNext } from "designer/ui/smart/button-vnext/button-vnext";

interface TOSAndCompleteProps {
    onDone(): Promise<void>;
    orgID: string;
    termsLink: string | undefined;
    privacyLink: string | undefined;
}

const TOSStyle = styled.div`
    a {
        text-decoration: underline !important;
    }
`;

const TOSAndComplete: React.FunctionComponent<TOSAndCompleteProps> = ({ orgID, onDone, termsLink, privacyLink }) => {
    const orgs = useSelector((state: RootState) => state.organizations);
    const [isLoading, setIsLoading] = React.useState(false);

    const onClickAccept = async () => {
        setIsLoading(true);
        trackEvent("sign up accept tos", {});
        await onDone();
    };

    const org = orgs.find(o => o.id === orgID);
    const orgDisplayName = org?.displayName || "";

    return (
        <TOSStyle>
            <hgroup>
                <OrgIcon size={"xlarge"} label={orgDisplayName} />
                <h1>You're ready to Glide!</h1>
            </hgroup>

            <p>
                <small>
                    By continuing, you agree to our{" "}
                    <a href={termsLink ?? ""} title="Terms of Service" target="_blank" rel="noopener noreferrer">
                        Terms
                    </a>{" "}
                    and{" "}
                    <a href={privacyLink ?? ""} title="Privacy Policy" target="_blank" rel="noopener noreferrer">
                        Privacy Policy
                    </a>
                    .
                </small>
            </p>

            <div className="continue">
                <ButtonVNext
                    onClick={onClickAccept}
                    size="xlg"
                    variant="default"
                    buttonType="primary"
                    label="Accept & Continue"
                    disabled={isLoading}
                />
            </div>
        </TOSStyle>
    );
};

export default TOSAndComplete;
